import { Component, Input, Output, EventEmitter, OnInit, NgModule, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { /*AbstractControl, */FormArray, FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';

import { TileRoutingModule } from './tile.routing.module';

import { Options } from './options';
import { Tile } from '../../models/tile';

@Component({
  selector: 'tile',
  template: `
  <div *ngIf="loading" class="tileGeneral" [formGroup]="form">
    <div class="row tileGeneral" formArrayName="tiles">
      <div *ngIf="options.edit" class="card tileAdd wow fadeIn">
        <div class="tileAddCenter"><a (click)="addTile()"><i class="fa fa-2x fa-plus"></i></a></div>
      </div>
      <div *ngFor="let tile of form.controls.tiles.controls; let i=index" [formGroupName]="i" class="card tile wow fadeIn" [ngStyle]="{'background-color': tile.controls.color.value}">
        <div class="card-block tileTop" (click)="!tile.controls.edit.value && searchRecord(tile)">
          <div [ngStyle]="{'display': (tile.controls.edit.value ? 'inline-block' :'')}">
            <input *ngIf="tile.controls.edit.value" [formControl]="tile.controls.caption" type="text" class="md-form white-text tileText"
            />
            <h4 *ngIf="!tile.controls.edit.value" class="tileTopText pull-left">{{tile.controls.caption.value}}</h4>
          </div>
          <div class="pull-right"><i class="fa fa-4x {{tile.controls.glyph.value}}"></i></div>
        </div>
        <div class="card-block tileBottom">
          <div [ngStyle]="{'display': (tile.controls.edit.value ? 'inline-block' :'')}">
            <input *ngIf="tile.controls.edit.value" [formControl]="tile.controls.help" type="text" class="md-form white-text tileText"
            />
            <p *ngIf="!tile.controls.edit.value" class="pull-left font-italic tileBottomText">{{tile.controls.help.value}}</p>
          </div>
          <div class="pull-right">
            <a *ngIf="!tile.controls.edit.value" (click)="searchRecord(tile)"><i class="fa fa-search fa-lg"></i></a>
            <a *ngIf="!tile.controls.edit.value" (click)="addRecord(tile)"><i class="fa fa-plus fa-lg"></i></a>
            <a *ngIf="options.edit && !tile.controls.edit.value" (click)="editTile(tile)"><i class="fa fa-edit fa-lg"></i></a>
            <a *ngIf="tile.controls.edit.value" (click)="canSave(i)"><i class="fa fa-check fa-lg"></i></a>
            <a *ngIf="tile.controls.edit.value" (click)="canDelete(i)"><i class="fa fa-trash fa-lg"></i></a>
          </div>
        </div>
      </div>
    </div>
  </div>`,
  styles: [`
  .tileGeneral {
    padding-right: 1rem;
    padding-left: 1rem;
    max-width: 100%;
    padding-top: .2rem;
  }
  
  .tileGeneral.row {
       display: flex;
       align-items: center;
       justify-content: center;
  }
  
  .tile {
      color: #fff;
      min-width: 250px;
      max-width: 350px;
      margin-right: .5rem;
      margin-left: .5rem;
      margin-bottom: .5rem;
      border-radius: .3rem;
  }
  
  .tileAdd {
      color: #fff;
      background-color: grey;
      height: 48px;
      width: 48px;
      margin-right: .5rem;
      margin-left: .5rem;
      margin-bottom: .5rem;
      border-radius: .3rem;
  }
  
  .tileAddCenter {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
  }
  
  .tileTop {
      border-bottom-color: white;
      border-bottom-style: solid;
      border-bottom-width: 1px;
      cursor: pointer;
  }
  
  .tileBottom {
      height: 5rem;
  }
  
  .tileTopText {
       max-width: calc(100% - 4rem);
       overflow: hidden;
       overflow-wrap: break-word;
  }
  
  .tileBottomText {
      max-width: calc(100% - 5rem);
      max-height: 3rem;
  }
  
  .tileText {
      margin-bottom: 0rem; 
      height: 1rem!important;
  }`],
  encapsulation: ViewEncapsulation.None,
})

export class TileComponent implements OnInit {
  public options: Options = new Options();
  //public tiles: Tile[] = new Array<Tile>();
  public edit: boolean = false;
  public form: FormGroup;
  public loading: boolean = false;
  public tiles: FormArray;

  constructor(public router: Router, public fb: FormBuilder) { }

  ngOnInit() {
  }

  /*this.form = this.fb.group(this.validators);
  this.form.valueChanges.subscribe((value) => {
    this.updated.emit(value);

  });
  this.form.statusChanges.subscribe((value) => {
    this.statusChange(value);
  });*/
  load(tiles: Tile[]) {
    this.form = this.fb.group({});
    if (!this.form.controls['tiles']) {
      this.form.addControl('tiles', this.fb.array([
      ]));
    }
    this.tiles = (this.form.controls['tiles'] as FormArray);
    for (let i = this.tiles.length - 1; i >= 0; i--) this.deleteTile(i);
    for (let i = 0; i <= tiles.length - 1; i++) {
      let tile: Tile = tiles[i];
      this.tiles.push(this.fb.group({
        caption: [tile.caption, Validators.required],
        help: [tile.help],
        color: [tile.color],
        glyph: [tile.glyph],
        id: [tile.id],
        link: [tile.link],
        edit: [tile.edit]
      }));
    }
    this.loading = true;
  }

  addTile() {
    let tile: Tile = new Tile();
    this.tiles.push(this.fb.group({
      caption: [tile.caption, Validators.required],
      help: [tile.help],
      color: [tile.color],
      glyph: [tile.glyph],
      id: [tile.id],
      link: [tile.link],
      edit: [true]
    }));
  }

  saveTile(i: number) {
  }

  canSave(i: number) {
    this.saveTile(i);
    this.editTile((this.tiles.at(i) as FormGroup));
  }

  editTile(tile: FormGroup) {
    tile.controls['edit'].patchValue(!tile.controls['edit'].value);
  }

  deleteTile(i: number) {
  }

  canDelete(i: number) {
    this.deleteTile(i);
    this.tiles.removeAt(i);
  }

  searchRecord(tile: FormGroup) {
    this.returnRoute(true, tile.controls['link'].value);
  }

  addRecord(tile: FormGroup) {
    this.returnRoute(false, tile.controls['link'].value);
  }

  returnRoute(search: boolean, pathRoute: string) {
    let commands: any[];
    if (pathRoute) {
      if (search) {
        commands = ['/', pathRoute];
      } else {
        commands = ['/', pathRoute, 0];
      }
      this.router.navigate(commands);
    }
  }
}
